module.exports = __webpack_public_path__ + "img/proses_custom_status.dd00c36c.svg";